"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ContentShareConstants_1 = require("../contentsharecontroller/ContentShareConstants");
var DefaultModality = /*#__PURE__*/function () {
  function DefaultModality(_id) {
    _classCallCheck(this, DefaultModality);
    this._id = _id;
  }
  _createClass(DefaultModality, [{
    key: "id",
    value: function id() {
      return this._id;
    }
  }, {
    key: "base",
    value: function base() {
      if (!this._id) {
        return '';
      }
      return this._id.split(DefaultModality.MODALITY_SEPARATOR)[0];
    }
  }, {
    key: "modality",
    value: function modality() {
      if (!this._id) {
        return '';
      }
      var components = this._id.split(DefaultModality.MODALITY_SEPARATOR);
      if (components.length === 2) {
        return components[1];
      }
      return '';
    }
  }, {
    key: "hasModality",
    value: function hasModality(modality) {
      return modality !== '' && this.modality() === modality;
    }
  }, {
    key: "withModality",
    value: function withModality(modality) {
      var m = new DefaultModality(this.base() + DefaultModality.MODALITY_SEPARATOR + modality);
      if (modality === '' || this.base() === '' || new DefaultModality(m._id).modality() !== modality) {
        return new DefaultModality(this.base());
      }
      return m;
    }
  }]);
  return DefaultModality;
}();
exports.default = DefaultModality;
DefaultModality.MODALITY_SEPARATOR = ContentShareConstants_1.default.Modality[0];
DefaultModality.MODALITY_CONTENT = ContentShareConstants_1.default.Modality.substr(1);